import axios from 'axios'

export default class interceptors {
    private instance: any;

    constructor() {
        // 创建axios实例
        this.instance = axios.create({ timeout: 1000 * 12 });
        // 初始化拦截器
        this.initInterceptors();
    }


    // 为了让http.ts中获取初始化好的axios实例
    public getInterceptors() {
        return this.instance;
    }

    // 初始化拦截器
    public initInterceptors() {

        /**
         * 请求拦截器
         * 每次请求前，如果存在token则在请求头中携带token
         */
        this.instance.interceptors.request.use(
            (config: any) => {
                // 登录流程控制中，根据本地是否存在token判断用户的登录情况
                // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
                // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
                // if (config.headers.isJwt) {
                //     const token = this.store.state.token;
                //     if (token) {
                //         config.headers.Authorization = 'Bearer ' + token;
                //     }
                // }
                // if (config.headers.setHead) {
                //     this.instance.defaults.headers.post['Content-Type'] = config.headers.setHead;
                // } else {
                //     // 设置post请求头
                //     this.instance.defaults.headers.post['Content-Type'] = 'text/javascript;charset=UTF-8';
                // }
                return config;
            },
            (error: any) => {
                console.log(error);
            },
        );
    }
}